import styled from "@emotion/styled";
import { theme } from "../../../utils/Theme";

export const Container = styled.div``;

export const Hidebutton = styled.div`
  display: none;
  @media (min-width: 768px) {
    display: unset;
    display: flex;
  }
`;
